<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleClose">
    <el-form ref="departmentForm" :model="formData" :rules="rules">
      <el-form-item label="所在部门" prop="organizationId">
        <el-cascader
          ref="cascaderGroup"
          style="width: 100%"
          v-model="formData.organizationId"
          placeholder="选择所在部门"
          :props="cascaderProps"
          :options="localOptions"
          @change="handleCascaderChange"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as API_Member from "@/api/train/member";

export default {
  name: 'SetDepartmentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      default: null
    },
    departmentOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogTitle: '修改部门',
      formData: {
        id: null,
        organizationId: []
      },
      rules: {
        organizationId: [
          { required: true, message: "请选择所在部门", trigger: "change" }
        ]
      },
      localOptions: [],
      firstLevelId: null
    };
  },
  computed: {
    cascaderProps() {
      return {
        multiple: true,
        checkStrictly: true,
        value: 'keyId',
        label: 'name',
        children: 'sonOrganizationVoList'
      };
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  mounted() {
    this.localOptions = JSON.parse(JSON.stringify(this.departmentOptions));
  },
  watch: {
    visible(val) {
      if (val && this.userId) {
        this.initData();
      }
    },
    departmentOptions: {
      immediate: true,
      handler() {
        this.localOptions = JSON.parse(JSON.stringify(this.departmentOptions));
      }
    }
  },
  methods: {
    handleCascaderChange(val) {
      if (!val || val.length === 0) {
        this.firstLevelId = null;
        return;
      }

      const currentFirstLevelId = val[0][0];

      if (this.firstLevelId === null) {
        this.firstLevelId = currentFirstLevelId;
      }

      const filtered = val.filter(path => path[0] === this.firstLevelId);

      if (filtered.length !== val.length) {
        this.formData.organizationId = filtered;
        this.$message.warning('只能选择同一机构下的部门');
      }
    },
    initData() {
      // 获取用户详细信息
      API_Member.memberInfo(this.userId).then((res) => {
        if (res.code == 200) {
          this.formData.id = res.data.id;
          this.formData.organizationId = [];

          // 处理部门数据
          res.data.usersGroupList.forEach(item => {
            let list = [];
            if (item.organizationId) {
              list.push('o' + item.organizationId);
            }
            if (item.teamId) {
              list.push('t' + item.teamId);
            }
            if (item.groupId) {
              list.push('g' + item.groupId);
            }
            this.formData.organizationId.push(list);
          });

          if (this.formData.organizationId.length > 0) {
            this.firstLevelId = this.formData.organizationId[0][0];
          }
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        id: null,
        organizationId: []
      };
      this.firstLevelId = null;
      if (this.$refs.departmentForm) {
        this.$refs.departmentForm.clearValidate();
      }
    },
    handleSubmit() {
      this.$refs.departmentForm.validate().then(() => {
        let organizationId = JSON.parse(JSON.stringify(this.formData.organizationId));
        let usersGroupList = [];

        organizationId.forEach(item => {
          let groupObj = {
            organizationId: null,
            teamId: null,
            groupId: null
          };

          item.forEach(iitem => {
            if (iitem[0] == 'o') {
              groupObj.organizationId = Number(iitem.substring(1, iitem.length));
            }
            if (iitem[0] == 't') {
              groupObj.teamId = Number(iitem.substring(1, iitem.length));
            }
            if (iitem[0] == 'g') {
              groupObj.groupId = Number(iitem.substring(1, iitem.length));
            }
          });

          usersGroupList.push(groupObj);
        });

        const params = {
          usersGroupList: usersGroupList,
          id: this.formData.id
        };

        API_Member.setGroup(params).then((res) => {
          this.$message.success("操作成功！");
          this.handleClose();
          this.$emit('success');
        });
      }).catch(() => {
        // 验证失败
      });
    }
  }
};
</script>

<style scoped lang="less">
</style>
